'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'image';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f03e';
var svgPathData = 'M384 48c26.5 0 48 21.5 48 48l0 320c0 26.5-21.5 48-48 48L64 464c-26.5 0-48-21.5-48-48L16 96c0-26.5 21.5-48 48-48l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm130 24.2c2.8-5.1 8.2-8.2 14-8.2s11.2 3.2 14 8.2l80 144c2.8 5 2.7 11-.2 15.9S357.7 400 352 400L96 400c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5 .8-16.4l64-96c2.6-3.9 6.8-6.5 11.4-7s9.3 1 12.7 4.1l34 31.4c1.8 1.7 4.3 2.4 6.7 2s4.5-1.9 5.7-4L258 232.2zM272 208c-11.6 0-22.3 6.3-28 16.5l-35.8 64.5-26.5-24.5c-6.9-6.4-16.2-9.4-25.5-8.3s-17.6 6.2-22.8 14l-64 96c-6.5 9.8-7.2 22.4-1.6 32.9S84.2 416 96 416l256 0c11.3 0 21.8-6 27.6-15.8s5.9-21.9 .4-31.8l-80-144c-5.6-10.2-16.4-16.5-28-16.5z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faImage = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;